import type { PackageProp } from '@vrlearning/lesson-schema';
import type { PropPlan } from '../world.js';

/** A package's props (V1) as the PropPlans a code world writes: the headset places them as it always has. */
export function propPlans(props: readonly PackageProp[]): PropPlan[] {
  return props.map((prop) => ({
    asset: prop.model,
    at: prop.at.map((at) => ({ pos: at.pos, turn: at.turn, scale: at.scale, tilt: at.tilt })),
    ...(prop.tint ? { tint: Number.parseInt(prop.tint.slice(1), 16) } : {}),
    instanced: prop.instanced,
    unit: prop.unit,
    matte: prop.matte,
    ...(prop.sway > 0 ? { foliage: { sway: prop.sway } } : {}),
    ...(prop.variant ? { variant: prop.variant } : {}),
    origin: prop.origin,
  }));
}
